var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened === true
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c("div", { staticClass: "modal-dialog modal-dialog-scrollable" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(
                    "\n                        Scheduler\n                    "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: { click: _vm.close },
                  },
                  [_vm._v("×")]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-body", staticStyle: { height: "400px" } },
                [
                  _vm.rm != null && _vm.isScheduling === true
                    ? _c("div", [_vm._m(0)])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rm != null &&
                  _vm.isScheduling === false &&
                  _vm.schedulingResult != null
                    ? _c("div", [
                        _c("p", [
                          _vm._v(
                            "Analyzed (unique) portfolios: " +
                              _vm._s(
                                _vm.schedulingResult.NumberOfUniquePortfolios
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Found (valid) portfolios: " +
                              _vm._s(
                                _vm.schedulingResult.NumberOfValidPortfolios
                              )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rm &&
                  _vm.isScheduling === false &&
                  _vm.schedulingResult == null
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Earliest start date:")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                staticClass: "form-control pointer bg-white",
                                attrs: { type: "text", readonly: "" },
                                domProps: {
                                  value: `${_vm.minStartDate.month}, ${_vm.minStartDate.year}`,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.show1 = !_vm.show1
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group-append" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.show1 = !_vm.show1
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-regular fa-calendar",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("month-picker", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.show1 === true,
                                  expression: "show1 === true",
                                },
                              ],
                              attrs: {
                                "min-date": _vm.minStartDateFrom,
                                "max-date": _vm.minStartDateTo,
                                "default-month": _vm.defaultMonth1,
                                "default-year": _vm.defaultYear1,
                              },
                              on: { change: _vm.onMinStartDateChange },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Latest start date:")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                staticClass: "form-control pointer bg-white",
                                attrs: { type: "text", readonly: "" },
                                domProps: {
                                  value: `${_vm.maxStartDate.month}, ${_vm.maxStartDate.year}`,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.show2 = !_vm.show2
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group-append" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.show2 = !_vm.show2
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-regular fa-calendar",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("month-picker", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.show2 === true,
                                  expression: "show2 === true",
                                },
                              ],
                              attrs: {
                                "min-date": _vm.maxStartDateFrom,
                                "max-date": _vm.maxStartDateTo,
                                "default-month": _vm.defaultMonth2,
                                "default-year": _vm.defaultYear2,
                              },
                              on: { change: _vm.onMaxStartDateChange },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary",
                    attrs: {
                      type: "button",
                      disabled: _vm.isScheduling === true,
                    },
                    on: { click: _vm.close },
                  },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      type: "button",
                      disabled: _vm.isScheduling === true,
                    },
                    on: {
                      click: _vm.handleOptimizeCorporateScenarioScheduleCommand,
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa-solid fa-robot fa-bounce mr-1",
                    }),
                    _vm._v(" Schedule now\n                    "),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "text-center text-primary my-5" }, [
      _c("i", {
        staticClass: "fa-solid fa-robot fa-beat-fade",
        staticStyle: { "font-size": "120px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }